var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRDex(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "201px",
    height: "188px",
    viewBox: "0 0 201 188",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(0.3173828 0.3174591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.952 39.0807L174.137 63.6645C166.262 60.4691 158.943 58.8714 152.178 58.8714C133.197 58.8714 120.88 68.0966 115.226 86.5474C115.226 133.963 115.529 167.102 116.135 185.965L89.3296 185.965C90.945 153.289 91.7527 127.933 91.7527 109.894C91.7527 97.3089 88.8753 79.1378 82.1652 63.6645C75.4551 48.1911 55.3249 39.0807 41.9048 33.9784L75.4551 0.236766C76.3211 5.35507 76.3638 20.7886 89.3296 34.4899C102.295 48.1911 109.005 59.8001 109.005 61.8923L111.429 55.0417C122.332 38.6525 138.851 33.9784 153.39 33.9784C161.063 33.9784 170.25 35.6792 180.952 39.0807Z",
    id: "r",
    fill: "#8E65FF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 39.0807L193.185 63.6645C185.31 60.4691 177.99 58.8714 171.226 58.8714C152.245 58.8714 139.928 68.0966 134.274 86.5474C134.274 133.963 134.577 167.102 135.183 185.965L108.377 185.965C109.993 153.289 110.8 127.933 110.8 109.894C110.8 97.3089 107.923 79.1378 101.213 63.6645C94.5027 48.1911 74.3725 39.0807 60.9524 33.9784L94.5027 0.236766C95.3687 5.35507 95.4114 20.7886 108.377 34.4899C121.343 48.1911 128.053 59.8001 128.053 61.8923L130.476 55.0417C141.38 38.6525 157.899 33.9784 172.437 33.9784C180.111 33.9784 189.298 35.6792 200 39.0807Z",
    id: "r-copy",
    fill: "#8E65FF",
    fillOpacity: 0.22186367,
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.952 185.965C88.8923 185.965 115.182 187.75 127.412 185.965C139.183 184.247 130.836 176.415 127.412 173.88C120.111 168.473 84.7641 166.883 69.952 166.883C32.7824 166.883 19.1584 170.381 12.1742 173.88C8.07728 175.932 -5.73012 184.374 2.65042 185.965C14.9219 188.294 47.8657 185.965 69.952 185.965Z",
    id: "Oval-2",
    fill: "#8E65FF",
    fillOpacity: 0.12381114,
    fillRule: "evenodd",
    stroke: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRDex);
export default __webpack_public_path__ + "static/media/rDEX.eea8027aba5bceab09cc60afa6f0b394.svg";
export { ForwardRef as ReactComponent };